// src/components/LogoMark.jsx
import React from 'react';
import logoPng from '../assets/logo.png';

export default function LogoMark({ className = 'w-6 h-6', alt = 'Spacebook logo' }) {
  return (
    <img
      src={logoPng}
      alt={alt}
      className={`object-contain bg-transparent ${className}`}
      style={{ filter: 'none', mixBlendMode: 'normal' }}
      draggable="false"
    />
  );
}
